import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { IconComponent } from 'src/app/shared/components/icon/icon.component';
import { PipesModule } from 'src/app/shared/pipes/pipe-module';
import { TempTaskModal } from '../../interfaces/task.interface';
import { MatHint } from '@angular/material/form-field';
import * as moment from 'moment';

@Component({
  selector: 'mg-task-temp-card',
  standalone: true,
  imports: [
    IconComponent,
    PipesModule,
    CommonModule,
    MatHint
  ],
  templateUrl: './task-temp-card.component.html',
  styleUrl: './task-temp-card.component.scss'
})
export class TaskTempCardComponent implements OnChanges{

  @Input() taskInfo: TempTaskModal
  @Input() isProjectModuleActive: boolean = false
  @Output() toAction = new EventEmitter<{sAction: string, oTask: TempTaskModal}>()

  constructor(
    private cdr: ChangeDetectorRef
  ){

  }

  ngOnChanges(changes: SimpleChanges): void {
    this.cdr.detectChanges()
  }

  fechaVisible(): string {
    const registro = moment(this.taskInfo?.dFecha_Registro);
    const inicio = this.fechaInicio();
    const fecha = inicio && inicio.clone().startOf('day').isAfter(registro.clone().startOf('day'))
      ? inicio
      : registro;
    return fecha.isValid() ? fecha.format('DD/MM/YYYY') : '';
  }

  private fechaInicio(): moment.Moment | null {
    const value = this.taskInfo?.dFecha_Inicio;
    if (!value) return null;
    const parsed = moment(value);
    return parsed.isValid() ? parsed : null;
  }

  deleteTask(){
    this.toAction.emit({sAction: 'delete', oTask:this.taskInfo})
  }

  editTask(){
    this.toAction.emit({sAction: 'edit', oTask:this.taskInfo})
  }

}
